import { BitmapLayer, picking, TerrainLayer, TileLayer } from "deck.gl"
import { _TerrainExtension as TerrainExtension } from '@deck.gl/extensions'
import { scaleLinear, scaleLog } from 'd3-scale'
import { evaluateColorMap } from "../core/colorMapService"
import { GEO_SERVER_BASE_URL } from "../core/constant"
import { AdministrativeBoundsLayer } from "../compositeLayer/administrativeBoundsLayer"
import { hideLoading, showLoading } from "../core/utils"
import { StreetCategoryLayer } from "../compositeLayer/streetCatagoryLayer";
import { simpleLayer } from "../compositeLayer/simpleLayer";
import { BuildingAreaLayer } from "../compositeLayer/buildingAreaLayer";
import { BuildingSubsidence } from "../compositeLayer/buildingSubsidence";
import { BuildingHeightLayer } from "../compositeLayer/buildingHeightLayer";
import { BuildingTypeLayer } from "../compositeLayer/buildingTypeLayer";
import { BuildingPopulationLayer } from "../compositeLayer/buildingPopulationLayer";
import { BuildingFloorRatioLayer } from "../compositeLayer/buildingFloorRatioLayer";
import { BuildingSharedWallLayer } from "../compositeLayer/buildingSharedWallLayer";
import { BuildingCoveredAreaLayer } from "../compositeLayer/buildingCoveredAreaLayer";
import { BuildingVolumeLayer } from "../compositeLayer/buildingVolumeLayer";
import { BuildingSolarLayer } from "../compositeLayer/buildingSolarLayer";
import { BuildingStreetAlignLayer } from "../compositeLayer/buildingStreetAlignLayer";
import { BuildingBuildingAlignLayer } from "../compositeLayer/buildingBuildingAlignLayer";
import { StreetCommutersLayer } from "../compositeLayer/streetCommutersLayer";
import { StreetCentralityLayer } from "../compositeLayer/StreetCentralityLayer";
import { StreetWeightedLayer } from "../compositeLayer/StreetWeightedLayer";
import { AccessibilityByFootLayer } from "../compositeLayer/AccessibilityByFootLayer";
import { AdministrativeDayPopLayer } from "../compositeLayer/AdministrativeDayPopLayer";
import { AdministrativeNightPopLayer } from "../compositeLayer/AdministrativeNightPopLayer";
import { AccessibilityByBikeLayer } from "../compositeLayer/AccessibilityByBikeLayer";
import { AccessibilityByCarLayer } from "../compositeLayer/AccessibilityByCarLayer";
import { UhiUrbanHeatLayer } from "../compositeLayer/UhiUrbanHeatLayer";
import { DSInSARLayer } from "../compositeLayer/DSInSARLayer";
import { PSInSARLayer } from "../compositeLayer/PSInSARLayer";
import { AdmBounds } from "../compositeLayer/AdmBounds"
import { DataFilterExtension } from '@deck.gl/extensions';
import { GetNormalizationDataH3 } from "../H3/GetNormalizationDataH3"
import { MVTLayer } from "deck.gl"
import { generateUrlGeoserverVector } from "../core/utils"
import { normalize } from "ol/color"
import { getLegendValueDescription } from "./legendService"
import { get } from "ol/proj"
import { useEffect } from "react"




function getColor(data, currentValueRange, colorMapIndex, logScale) {
    if ((!data.properties.val) || isNaN(data.properties.val)) {
        return [200, 200, 200]
    }

    const tmp_min = currentValueRange[0]
    const tmp_max = currentValueRange[1]

    const value = logScale
        ? scaleLog()
            .domain([
                Math.max(tmp_min, 0.00000001),
                Math.max(tmp_max, 0.00000002)])
            .range([0, 1])
            .clamp(true)(Math.max(data.properties.val, 0.00000001))
        : scaleLinear()
            .domain([tmp_min, tmp_max])
            .range([0, 1])
            .clamp(true)(data.properties.val)
    return evaluateColorMap(value, colorMapIndex, false, true);
}

export function renderVectorLayer(props) {
    const { data, color, height, colorMapOpacity, zoom } = props;

    switch (data['composite_layer']) {
        case 'AdministrativeBoundsLayer':
            return AdmBounds(data['geoserver_workspace'], data['geoserver_layer_name'], false, colorMapOpacity, zoom, data['source_url'],color);
        case 'StreetCategoryLayer':
            return new StreetCategoryLayer(data['geoserver_workspace'], data['geoserver_layer_name'], false, colorMapOpacity, zoom, data['source_url'])
        case 'BuildingHeightLayer':
            return BuildingHeightLayer(data['geoserver_workspace'], data['geoserver_layer_name'], false, colorMapOpacity, zoom, data['source_url']);
        case 'BuildingTypeLayer':
            return BuildingTypeLayer(data['geoserver_workspace'], data['geoserver_layer_name'], false, colorMapOpacity, zoom, data['source_url']);
        case 'BuildingAreaLayer':
            return BuildingAreaLayer(data['geoserver_workspace'], data['geoserver_layer_name'], false, colorMapOpacity, zoom, data['source_url'])
        case 'BuildingPopulationLayer':
            return BuildingPopulationLayer(data['geoserver_workspace'], data['geoserver_layer_name'], false, colorMapOpacity, zoom, data['source_url'])
        case 'BuildingSubsidence':
            return new BuildingSubsidence(data['geoserver_workspace'], data['geoserver_layer_name'], false, colorMapOpacity, zoom, data['source_url'])
        case 'BuildingFloorRatioLayer':
            return new BuildingFloorRatioLayer(data['geoserver_workspace'], data['geoserver_layer_name'], false, colorMapOpacity, zoom, data['source_url'])
        case 'BuildingSharedWallLayer':
            return new BuildingSharedWallLayer(data['geoserver_workspace'], data['geoserver_layer_name'], false, colorMapOpacity, zoom, data['source_url'])
        case 'BuildingCoveredAreaLayer':
            return new BuildingCoveredAreaLayer(data['geoserver_workspace'], data['geoserver_layer_name'], false, colorMapOpacity, zoom, data['source_url'])
        case 'BuildingVolumeLayer':
            return new BuildingVolumeLayer(data['geoserver_workspace'], data['geoserver_layer_name'], false, colorMapOpacity, zoom, data['source_url'])
        case 'BuildingSolarLayer':
            return new BuildingSolarLayer(data['geoserver_workspace'], data['geoserver_layer_name'], false, colorMapOpacity, zoom, data['source_url'])
        case 'BuildingStreetAlignLayer':
            return new BuildingStreetAlignLayer(data['geoserver_workspace'], data['geoserver_layer_name'], false, colorMapOpacity, zoom, data['source_url'])
        case 'BuildingBuildingAlignLayer':
            return new BuildingBuildingAlignLayer(data['geoserver_workspace'], data['geoserver_layer_name'], false, colorMapOpacity, zoom, data['source_url'])
        case 'StreetCommutersLayer':
            return new StreetCommutersLayer(data['geoserver_workspace'], data['geoserver_layer_name'], false, colorMapOpacity, zoom, data['source_url'])
        case 'StreetCentralityLayer':
            return new StreetCentralityLayer(data['geoserver_workspace'], data['geoserver_layer_name'], false, colorMapOpacity, zoom, data['source_url'])
        case 'StreetWeightedLayer':
            return new StreetWeightedLayer(data['geoserver_workspace'], data['geoserver_layer_name'], false, colorMapOpacity, zoom, data['source_url'])
        case 'AccessibilityByFootLayer':
            return new AccessibilityByFootLayer(data['geoserver_workspace'], data['geoserver_layer_name'], false, colorMapOpacity, zoom, data['source_url'])
        case 'AccessibilityByBikeLayer':
            return new AccessibilityByBikeLayer(data['geoserver_workspace'], data['geoserver_layer_name'], false, colorMapOpacity, zoom, data['source_url'])
        case 'AccessibilityByCarLayer':
            return new AccessibilityByCarLayer(data['geoserver_workspace'], data['geoserver_layer_name'], false, colorMapOpacity, zoom, data['source_url'])
        case 'AdministrativeDayPopLayer':
            return new AdministrativeDayPopLayer(data['geoserver_workspace'], data['geoserver_layer_name'], false, colorMapOpacity, zoom, data['source_url'])
        case 'AdministrativeNightPopLayer':
            return new AdministrativeNightPopLayer(data['geoserver_workspace'], data['geoserver_layer_name'], false, colorMapOpacity, zoom, data['source_url'])
        case 'UhiUrbanHeatLayer':
            return  UhiUrbanHeatLayer(data['geoserver_workspace'], data['geoserver_layer_name'], false, colorMapOpacity, zoom, data['source_url'])
        case 'DSInSARLayer':
            return new DSInSARLayer(data['geoserver_workspace'], data['geoserver_layer_name'], false, colorMapOpacity, zoom, data['source_url'])
        case 'PSInSARLayer':
            return PSInSARLayer(data['geoserver_workspace'], data['geoserver_layer_name'], false, colorMapOpacity, zoom, data['source_url'],color)
        default:
            return simpleLayer(data['geoserver_workspace'], data['geoserver_layer_name'])

    }
}

export function renderVectorLayer3D(props) {
    const { data, color, height, colorMapOpacity, zoom } = props;

    switch (data['composite_layer']) {
        case 'AdministrativeBoundsLayer':
            return new AdministrativeBoundsLayer(data['geoserver_workspace'], data['geoserver_layer_name'], true, colorMapOpacity, zoom, data['source_url']);
        case 'StreetCategoryLayer':
            return new StreetCategoryLayer(data['geoserver_workspace'], data['geoserver_layer_name'], true, colorMapOpacity, zoom, data['source_url'])
        case 'BuildingHeightLayer':
            return BuildingHeightLayer(data['geoserver_workspace'], data['geoserver_layer_name'], true, colorMapOpacity, zoom, data['source_url']);
        case 'BuildingAreaLayer':
            return BuildingAreaLayer(data['geoserver_workspace'], data['geoserver_layer_name'], true, colorMapOpacity, zoom, data['source_url'])
        case 'BuildingTypeLayer':
            return BuildingTypeLayer(data['geoserver_workspace'], data['geoserver_layer_name'], true, colorMapOpacity, zoom, data['source_url'])
        case 'BuildingPopulationLayer':
            return BuildingPopulationLayer(data['geoserver_workspace'], data['geoserver_layer_name'], true, colorMapOpacity, zoom, data['source_url'])
        case 'BuildingSubsidence':
            return new BuildingSubsidence(data['geoserver_workspace'], data['geoserver_layer_name'], true, colorMapOpacity, zoom, data['source_url'])
        case 'BuildingFloorRatioLayer':
            return new BuildingFloorRatioLayer(data['geoserver_workspace'], data['geoserver_layer_name'], true, colorMapOpacity, zoom, data['source_url'])
        case 'BuildingSharedWallLayer':
            return new BuildingSharedWallLayer(data['geoserver_workspace'], data['geoserver_layer_name'], true, colorMapOpacity, zoom, data['source_url'])
        case 'BuildingCoveredAreaLayer':
            return new BuildingCoveredAreaLayer(data['geoserver_workspace'], data['geoserver_layer_name'], true, colorMapOpacity, zoom, data['source_url'])
        case 'BuildingVolumeLayer':
            return new BuildingVolumeLayer(data['geoserver_workspace'], data['geoserver_layer_name'], true, colorMapOpacity, zoom, data['source_url'])
        case 'BuildingSolarLayer':
            return new BuildingSolarLayer(data['geoserver_workspace'], data['geoserver_layer_name'], true, colorMapOpacity, zoom, data['source_url'])
        case 'BuildingStreetAlignLayer':
            return new BuildingStreetAlignLayer(data['geoserver_workspace'], data['geoserver_layer_name'], true, colorMapOpacity, zoom, data['source_url'])
        case 'BuildingBuildingAlignLayer':
            return new BuildingBuildingAlignLayer(data['geoserver_workspace'], data['geoserver_layer_name'], true, colorMapOpacity, zoom, data['source_url'])
        case 'StreetCommutersLayer':
            return new StreetCommutersLayer(data['geoserver_workspace'], data['geoserver_layer_name'], true, colorMapOpacity, zoom, data['source_url'])
        case 'StreetCentralityLayer':
            return new StreetCentralityLayer(data['geoserver_workspace'], data['geoserver_layer_name'], true, colorMapOpacity, zoom, data['source_url'])
        case 'StreetWeightedLayer':
            return new StreetWeightedLayer(data['geoserver_workspace'], data['geoserver_layer_name'], true, colorMapOpacity, zoom, data['source_url'])
        case 'AccessibilityByFootLayer':
            return new AccessibilityByFootLayer(data['geoserver_workspace'], data['geoserver_layer_name'], true, colorMapOpacity, zoom, data['source_url'])
        case 'AccessibilityByBikeLayer':
            return new AccessibilityByBikeLayer(data['geoserver_workspace'], data['geoserver_layer_name'], true, colorMapOpacity, zoom, data['source_url'])
        case 'AccessibilityByCarLayer':
            return new AccessibilityByCarLayer(data['geoserver_workspace'], data['geoserver_layer_name'], true, colorMapOpacity, zoom, data['source_url'])
        case 'AdministrativeDayPopLayer':
            return new AdministrativeDayPopLayer(data['geoserver_workspace'], data['geoserver_layer_name'], true, colorMapOpacity, zoom, data['source_url'])
        case 'AdministrativeNightPopLayer':
            return new AdministrativeNightPopLayer(data['geoserver_workspace'], data['geoserver_layer_name'], true, colorMapOpacity, zoom, data['source_url'])
        case 'UhiUrbanHeatLayer':
            return UhiUrbanHeatLayer(data['geoserver_workspace'], data['geoserver_layer_name'], true, colorMapOpacity, zoom, data['source_url'])
        case 'DSInSARLayer':
            return new DSInSARLayer(data['geoserver_workspace'], data['geoserver_layer_name'], true, colorMapOpacity, zoom, data['source_url'])
        case 'PSInSARLayer':
            return PSInSARLayer(data['geoserver_workspace'], data['geoserver_layer_name'], true, colorMapOpacity, zoom, data['source_url'],color)
        case 'H3Exposure':
            return renderH3(data['geoserver_workspace'], data['geoserver_layer_name'], true, color, height, colorMapOpacity, zoom, data['source_url'])
    }
}

export function linearScale(data, domain, range) {
    return scaleLinear().domain(domain).range(range).clamp(true)(data)
}

export function logScale(data, domain, range, base) {
    const logScale = scaleLog().domain(domain).range([0, 10]).base(base).clamp(true)(data)
    return linearScale(logScale, [0, 10], range)
}



function renderH3(geoserver_workspace, geoserver_layer_name, is3d, color, height, colorMapOpacity, zoom) {
    const minmax = GetNormalizationDataH3(zoom, height)
    const dataSource = generateUrlGeoserverVector(geoserver_workspace, geoserver_layer_name)
    const domain = [0, 0.5, 1]
    const range = [[50, 205, 50], [255, 255, 0], [255, 50, 100]]
    function FillH3Color(data) {
        return linearScale(data, domain, range) === undefined ? [50, 205, 50] : linearScale(data, domain, range)
    }
    function NormalizeData(data) {
        const normalizedData = (data - minmax.min) / (minmax.max - minmax.min) * 1000000
        return normalizedData
    }




    return [
        new MVTLayer({
            id: 'h3Layer',
            data: dataSource,
            onTileLoad: showLoading,
            onViewportLoad: hideLoading,
            opacity: colorMapOpacity / 100,
            stroked: true,
            filled: true,
            getLineColor: [255, 255, 255],
            getFillColor: d => FillH3Color(d.properties[color]),
            getLineWidth: 10.0,
            lineWidthMinPixels: 10.0,
            pickable: true,
            getElevation: d => NormalizeData(d.properties[height]),
            terrainDrawMode: 'offset',
            getFilterValue: d => Math.min(d.properties['avg_building_height'], d.properties['num_buildings'], d.properties['population'], d.properties['building_area'], d.properties['num_res_buildings']),
            filterRange: [1, Infinity],
            extensions: is3d
                ? [new DataFilterExtension({ filterSize: 1 }), new TerrainExtension()]
                : [new DataFilterExtension({ filterSize: 1 })],
            extruded: true,
            updateTriggers: {
                getFillColor: () => color,
                getElevation: () => height
            },
        }),
    ]
}

export function renderRasterLayer(props) {
    const { data, colorMapName, colorMapOpacity } = props;
    //const resource = data['geoserver_workspace'] + ':' + data['geoserver_layer_name']
    //const resourceStyle = data['geoserver_workspace'] + ':' + data['name']
    const geoserver_layer_name = data['geoserver_layer_name']
    const resource = data['geoserver_workspace'] + ':' + data['geoserver_layer_name']
    const resourceStyle = data['geoserver_workspace'] + ':' + geoserver_layer_name.substr(0, geoserver_layer_name.lastIndexOf("_"))
    const style = (data['is_time'] ? resourceStyle : resource) + '-' + colorMapName
    const dataSource = GEO_SERVER_BASE_URL +
        '?layer=' + resource +
        '&style=' + style +
        '&tilematrixset=EPSG:900913' +
        '&Service=WMTS' +
        '&Request=GetTile' +
        '&Version=1.0.0' +
        '&Format=image/vnd.jpeg-png8' +
        '&TileMatrix=EPSG:900913:{z}' +
        '&TileCol={x}' +
        '&TileRow={y}'


        return new TileLayer({
            data: dataSource,
            onTileLoad: showLoading,
            onViewportLoad: hideLoading,
            pickable: true,
            opacity: colorMapOpacity / 100,
    
            renderSubLayers: props => {
                const {
                    bbox: { west, south, east, north }
                } = props.tile;
    
                return new BitmapLayer(props, {
                    data: null,
                    image: props.data,
                    minZoom: 4,
                    maxZoom: 7,
                    bounds: [west, south, east, north]
                });
            }
        });

}

export function renderRasterLayer3D(props) {
    const { data, colorMapName, colorMapOpacity } = props;
    const geoserver_layer_name = data['geoserver_layer_name']
    const resource = data['geoserver_workspace'] + ':' + data['geoserver_layer_name']
    const resourceStyle = data['geoserver_workspace'] + ':' + geoserver_layer_name.substr(0, geoserver_layer_name.lastIndexOf("_"))
    const style = (data['is_time'] ? resourceStyle : resource) + '-' + colorMapName
    const dataSource = GEO_SERVER_BASE_URL +
        '?layer=' + resource +
        '&style=' + style +
        '&tilematrixset=EPSG:900913' +
        '&Service=WMTS' +
        '&Request=GetTile' +
        '&Version=1.0.0' +
        '&Format=image/vnd.jpeg-png8' +
        '&TileMatrix=EPSG:900913:{z}' +
        '&TileCol={x}' +
        '&TileRow={y}'


    return new TileLayer({
        data: dataSource,
        onTileLoad: showLoading,
        onViewportLoad: hideLoading,

        opacity: colorMapOpacity / 100,
        extensions: [new TerrainExtension()],
        terrainDrawMode: 'drape',

        renderSubLayers: props => {
            const {
                bbox: { west, south, east, north }
            } = props.tile;

            return new BitmapLayer(props, {
                data: null,
                image: props.data,
                minZoom: 4,
                maxZoom: 7,
                bounds: [west, south, east, north]
            });
        }
    });

}

export function renderTerrain(isView3d) {
    return new TerrainLayer({
        id: 'terrain-source',
        elevationData: 'https://s3.amazonaws.com/elevation-tiles-prod/terrarium/{z}/{x}/{y}.png',
        elevationDecoder: isView3d ? {
            rScaler: 256,
            gScaler: 1,
            bScaler: 1 / 256,
            offset: -32768
        } : {
            rScaler: 0,
            gScaler: 0,
            bScaler: 0,
            offset: 0
        },
        texture: null,
        maxZoom: 14,
        material: {
            diffuse: 1
        },
        operation: 'terrain+draw'
    });
}

export function TileMapLayer(mapTheme) {

    return new TileLayer({
        id: 'tile-map',
        data: 
        //process.env.NODE_ENV !== 'production'
        //    ? [
        //        'https://a.tile.openstreetmap.org/{z}/{x}/{y}.png',
        //        'https://b.tile.openstreetmap.org/{z}/{x}/{y}.png',
        //        'https://c.tile.openstreetmap.org/{z}/{x}/{y}.png'
        //    ]
        //    : 
            [`https://api.maptiler.com/maps/${mapTheme}?key=${window.__env__?.REACT_APP_MAPTILER_TOKEN ?? process.env.REACT_APP_MAPTILER_TOKEN}`],

        maxRequests: 40,
        opacity: 1,
        highlightColor: [60, 60, 60, 40],
        tileSize: 512,
        zoomOffset: devicePixelRatio === 1 ? -1 : 0,
        renderSubLayers: props => {
            const {
                bbox: { west, south, east, north }
            } = props.tile;

            return [
                new BitmapLayer(props, {
                    data: null,
                    image: props.data,
                    bounds: [west, south, east, north]
                }),

            ];
        },
        terrainDrawMode: 'drape',
        extensions: [new TerrainExtension()],
    })
}

export function TileMapLayer2D(mapTheme) {

    return new TileLayer({
        id: 'tile-map-2d',
        data: 
        //process.env.NODE_ENV !== 'production'
        //    ? [
        //        'https://a.tile.openstreetmap.org/{z}/{x}/{y}.png',
        //        'https://b.tile.openstreetmap.org/{z}/{x}/{y}.png',
        //        'https://c.tile.openstreetmap.org/{z}/{x}/{y}.png'
        //    ]
        //    : 
            [`https://api.maptiler.com/maps/${mapTheme}?key=${window.__env__?.REACT_APP_MAPTILER_TOKEN ?? process.env.REACT_APP_MAPTILER_TOKEN}`],

        maxRequests: 20,
        opacity: 1,
        tileSize: 512,
        zoomOffset: devicePixelRatio === 1 ? -1 : 0,
        renderSubLayers: props => {
            const {
                bbox: { west, south, east, north }
            } = props.tile;

            return [
                new BitmapLayer(props, {
                    data: null,
                    image: props.data,
                    bounds: [west, south, east, north]
                }),

            ];
        },
    })
}

